/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useRef, useState,useEffect } from "react";
import CalendarMarketingHomeSection from "../../../Home/CalendarMarketingHomeSection";
import BannerSectionB2C from "../../../b2cComponents/homepage/BannerSectionB2C";
import PopularVideoCourse from "../../../b2cComponents/homepage/PopularVideoCourse";
import SubscriptionPriceSectionComponent from "../../SubscriptionPage/SubscriptionPriceSection/SubscriptionPriceSectionComponent";
import CoursesWithSubscription from "../../UsefulEntity/CoursesWithSubscription";
import UsefulCourses from "../../UsefulEntity/UsefulCourses";
import UsefulVideos from "../../UsefulEntity/UsefulVideos";
import "./CustomerHomePageComponent.scss"
import Loader from "../../../Loader/Loader";
import { getActiveHeader } from "../../../../redux/home/actions";
import { useDispatch } from "react-redux";

const CustomerHomePageComponent = ({
    isLoading,
    setIsLoading
}) => {

    const observer = useRef();
    const observer2 = useRef();
    let dispatch = useDispatch();
    
    const [fetchUsefullData, setFetchUsefullData] = useState(false)
    const [fetchBottomData, setFetchBottomData] = useState(false)

    const paginateUFCB = useCallback((node) => {
        if (fetchUsefullData) return;
        if (observer.current) observer.current.disconnect()

        observer.current = new IntersectionObserver((entries) => {
            console.log(entries[0], entries[0].isIntersecting)
            if (entries[0].isIntersecting && !fetchUsefullData) {
                setFetchUsefullData(true)
            }
        })
        if (node) observer.current.observe(node);
    }, [])

    const paginateBMCB = useCallback((node) => {
        if (fetchBottomData) return;
        if (observer2.current) observer2.current.disconnect()

        observer2.current = new IntersectionObserver((entries) => {
            console.log(entries[0], entries[0].isIntersecting)
            if (entries[0].isIntersecting && !fetchBottomData) {
                setFetchBottomData(true)
            }
        })
        if (node) observer2.current.observe(node);
    }, [])

    useEffect(() => {
        
     dispatch(getActiveHeader('home'));
    }, []);

    return (
        <>
            <PopularVideoCourse />
            <div className="linrs"></div>
            <div ref={paginateUFCB} className="calendar-homesection pt-5g pb-4">
                <CalendarMarketingHomeSection />
            </div>
            <UsefulVideos fetchData={fetchUsefullData} />
            <UsefulCourses fetchData={fetchUsefullData} />
            <div ref={paginateBMCB}>
                <BannerSectionB2C />
            </div>
            <CoursesWithSubscription fetchData={fetchBottomData} is_home={true} from_sub={false}/>
            <SubscriptionPriceSectionComponent 
                fetchData={fetchBottomData}
                setMainPageLoading={setIsLoading} 
            />
        </>
    )
}

export default CustomerHomePageComponent;